export default __webpack_public_path__ + "static/Operational-65a30b39ec6c45f5a0eccb5fe2ff92f2.png";